<template>
<v-dialog
    v-model="comparephotoModal"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="no-radius" 
  >
  <v-card class="no-border">
    <v-card-title class="pillar-card-title" v-bind:style="{ backgroundColor: companyPrimaryColor}">
      <h2>Foto's bekijken</h2>
      <div class="hogans-modal-header-close" @click="closedialog()"></div>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-container class="text--center" grid-list-xl style="max-width: 100%">
        <v-layout row wrap>
          <v-flex xs12 class="turntolandscape">
            <v-row justify="space-around" class="pa-4">
              <v-icon :color="companyPrimaryColor" size="100px">
                screen_rotation
              </v-icon>
            </v-row>
            <p class="ma-0" style="width: 100%; text-align: center;">
              Draai de tablet terug naar landscape om te vergelijken
            </p>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="landscapeturn">
          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs9>
                <v-img
                  width="350"
                  height="460"
                  :src="imageLeft"
                  :aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-container fill-height fluid pa-2>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span v-if="BAleft == 0" class="BeforeAfter">Before</span>
                        <span v-else-if="BAleft == 1" class="BeforeAfter">After </span>
                        <span v-else class="BeforeAfter">Controle</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <template slot="placeholder">
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-flex>

              <v-flex xs3>
                <div v-for="(photos, index) in lastclientPhotosLeft" :key="index">
                  <img
                    v-show="photos.photoCollection.front_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.front_thumb"
                    @click="imageLeft = photos.photoCollection.front"
                  >
                  <img
                    v-show="photos.photoCollection.side_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.side_thumb"
                    @click="imageLeft = photos.photoCollection.side"
                  >
                  <img
                    v-show="photos.photoCollection.back_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.back_thumb"
                    @click="imageLeft = photos.photoCollection.back"
                  >
                  <img
                    v-show="photos.photoCollection.extra_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.extra_thumb"
                    @click="imageLeft = photos.photoCollection.extra"
                  >
                  <img
                    v-show="photos.photoCollection.extra2_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.extra2_thumb"
                    @click="imageLeft = photos.photoCollection.extra2"
                  >
                  <img
                    v-show="photos.photoCollection.extra3_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.extra3_thumb"
                    @click="imageLeft = photos.photoCollection.extra3"
                  >
                </div>
                <div v-if="$store.state.userRole == 'superadmin' || $store.state.userRole == 'admin' || $store.state.userRole == 'manager'">
                  <h3>Foto's verwijderen</h3>
                  <v-tooltip bottom style="cursor: pointer;">
                      <template v-slot:activator="{ on }"> 
                        <v-btn v-on="on" fab small dark :color="companyPrimaryColor" @click="removePhotos(lastclientPhotosLeft)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    <span style="color: #fff">Alle foto's van {{ selectedDateLeft | moment("D MMM YYYY - H:mm")}}u verwijderen</span>
                  </v-tooltip> 
                </div>
                
              </v-flex>
               <v-flex xs12>
                <v-select
                  outlined
                  style="width: 100%"
                  background-color="background"
                  :color="companyPrimaryColor"
                  :items="dateCompare"
                  item-text="dateLabel"
                  item-value="dateBooking"
                  v-model="selectedDateLeft"
                  v-on:input="selectDatePhoto('Left');"
                  :menu-props="{ maxHeight: '300' }"
                  label="Kies een datum"
                  persistent-hint
                ></v-select>
              </v-flex>
            </v-layout>
           
          </v-flex>

          <v-flex xs6 v-if="lastclientPhotosRight.length">
            <v-layout row wrap>
              <v-flex xs9>
                <v-img
                  width="350"
                  height="460"
                  :src="imageRight"
                  :aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-container fill-height fluid pa-2>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span v-if="BAright == 0" class="BeforeAfter">Before</span>
                        <span v-else-if="BAright == 1" class="BeforeAfter">After </span>
                        <span v-else class="BeforeAfter">Controle</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <template slot="placeholder">
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-flex>

              <v-flex xs3>
                <div v-for="(photos, index) in lastclientPhotosRight" :key="index">
                  <img
                    v-show="photos.photoCollection.front_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.front_thumb"
                    @click="imageRight = photos.photoCollection.front"
                  >
                  <img
                    v-show="photos.photoCollection.side_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.side_thumb"
                    @click="imageRight = photos.photoCollection.side"
                  >
                  <img
                    v-show="photos.photoCollection.back_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.back_thumb"
                    @click="imageRight = photos.photoCollection.back"
                  >
                  <img
                    v-show="photos.photoCollection.extra_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.extra_thumb"
                    @click="imageRight = photos.photoCollection.extra"
                  >
                  <img
                    v-show="photos.photoCollection.extra2_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.extra2_thumb"
                    @click="imageRight = photos.photoCollection.extra2"
                  >
                  <img
                    v-show="photos.photoCollection.extra3_thumb"
                    :width="calculateHeight()"
                    :height="calculateHeight()"
                    :src="photos.photoCollection.extra3_thumb"
                    @click="imageRight = photos.photoCollection.extra3"
                  >
                </div>
                <div v-if="$store.state.userRole == 'superadmin' || $store.state.userRole == 'admin' || $store.state.userRole == 'manager'">
                  <h3>Foto's verwijderen</h3>
                  <v-tooltip bottom style="cursor: pointer;">
                      <template v-slot:activator="{ on }"> 
                        <v-btn v-on="on" fab small dark :color="companyPrimaryColor" @click="removePhotos(lastclientPhotosRight)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    <span style="color: #fff">Alle foto's van {{ selectedDateRight | moment("D MMM YYYY - H:mm")}}u verwijderen</span>
                  </v-tooltip> 
                </div>
              </v-flex>
              <v-flex xs12>
                <v-select
                  outlined
                  style="width: 100%"
                  background-color="background"
                  :color="companyPrimaryColor"
                  :items="dateCompare"
                  item-text="dateLabel"
                  item-value="dateBooking"
                  v-model="selectedDateRight"
                  v-on:input="selectDatePhoto('Right')"
                  :menu-props="{ maxHeight: '300' }"
                  label="Kies een datum"
                  persistent-hint
                ></v-select>
              </v-flex>
            </v-layout>

            
          </v-flex>
        </v-layout>
      </v-container>

      
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import axios from "axios";
import uniqid from "uniqid";
import moment from "moment";
import { bus } from "../../main";
import db from "../../firebase/init";
export default {
  props: [
    "chosenCustomerInfo",
    "activeComp"
    ],
  data() {
    return {
      comparephotoModal: false,
      leeg: "leeg",
      HogansDataCustomer: [],
      sorter: null, //Zet foto op de juiste plek
      imageLeft: "",
      imageRight: "",
      BAleft: 1,
      BAright: 1,
      lastclientPhotosLeft: [],
      lastclientPhotosRight: [],

      clientPhotoDates: [],

      selectedDateLeft: null,
      selectedDateRight: null,

      photoCollection: {
        front: null,
        front_thumb: null,
        side: null,
        side_thumb: null,
        back: null,
        back_thumb: null,
        extra: null,
        extra_thumb: null
      },
      dateCompare: [],
      customerID: null,
    };
  },

  created() {
    bus.$on("compareClientPhotos", (customerID) =>{
      this.comparephotoModal = true;
      this.customerID = customerID;
      this.getComparePhotos(customerID)
    });
  },

  methods: {


    getComparePhotos(customerID) {
      this.dateCompare = []
      this.lastclientPhotosLeft = [];
      this.lastclientPhotosRight = [];

      //Client Photos Links
      db.collection("clientphotos")
        .where("company", "==", this.activeComp)
        .where("salonhub_ID", "==", Number(customerID))
        .orderBy("datePhoto", "desc")
        .limit(1)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.data().photoBA == 0) {
              this.BAleft = 0;
            } else {
              this.BAleft = 1;
            }
            let clientphoto = doc.data();
            clientphoto.id = doc.id;
            this.lastclientPhotosLeft.push(clientphoto);
            this.selectedDateLeft = clientphoto.datePhoto;
          });
        })
        .then(() => {
          this.imageLeft = this.lastclientPhotosLeft[0].photoCollection.front;

          //Client Photos Rechts
          db.collection("clientphotos")
            .where("company", "==", this.activeComp)
            .where("salonhub_ID", "==", Number(customerID))
            .where("datePhoto", "<", this.lastclientPhotosLeft[0].datePhoto)
            .orderBy("datePhoto", "desc")
            .limit(1)
            .get()
            .then(snapshot => {
              snapshot.forEach(doc => {
                if (doc.data().photoBA == 0) {
                  this.BAright = 0;
                } else {
                  this.BAright = 1;
                }
                let clientphoto = doc.data();
                clientphoto.id = doc.id;
                this.lastclientPhotosRight.push(clientphoto);
                this.selectedDateRight = clientphoto.datePhoto;
              });
            })
            .then(() => {
              if (this.lastclientPhotosRight.length == 0) {
                //Niks doen
              } else {
                this.imageRight = this.lastclientPhotosRight[0].photoCollection.front;
              }
            })

            .catch(error => {
              // The document probably doesn't exist.
              console.error("Error document: ", error);
            });
        })

        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error document: ", error);
        });

      //Binnen halen datums voor Links en Rechts
      db.collection("clientphotos")
        .where("company", "==", this.activeComp)
        .where("salonhub_ID", "==", Number(customerID))
        .orderBy("datePhoto", "desc")
        .limit(10)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            //Onderscheid tussen Before, After and Controle
            if (doc.data().photoBA == 0) {
              this.dateCompare.push({
                dateLabel:
                  moment(doc.data().datePhoto).format("D MMMM YYYY - HH:mm") +
                  " Before",
                dateBooking: doc.data().datePhoto
              });
            }
            else if (doc.data().photoBA == 1) {
              this.dateCompare.push({
                dateLabel:
                  moment(doc.data().datePhoto).format("D MMMM YYYY - HH:mm") +
                  " After",
                dateBooking: doc.data().datePhoto
              });
            }  
            else {
              this.dateCompare.push({
                dateLabel:
                  moment(doc.data().datePhoto).format("D MMMM YYYY - HH:mm") +
                  " Controle",
                dateBooking: doc.data().datePhoto
              });
            }
          });
        })
        .then(() => {
          // console.log("Dates zijn binnen geladen.");
        })

        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error document: ", error);
        });
    },

    selectDatePhoto(side) {
      if (side == "Left") {
        this.lastclientPhotosLeft = [];

        db.collection("clientphotos")
          .where("company", "==", this.activeComp)
          .where("salonhub_ID", "==", Number(this.chosenCustomerInfo.id))
          .where("datePhoto", "==", this.selectedDateLeft)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              if (doc.data().photoBA == 0) {
                this.BAleft = 0;
              } else {
                this.BAleft = 1;
              }

              let clientphoto = doc.data();
              clientphoto.id = doc.id;
              this.lastclientPhotosLeft.push(clientphoto);
            });
          })
          .then(() => {
            if (this.lastclientPhotosLeft.length == 0) {
                //Niks doen
              } else {
                this.imageLeft = this.lastclientPhotosLeft[0].photoCollection.front;
              }
          })
          .catch(error => {
            // The document probably doesn't exist.
            console.error("Error document: ", error);
          });
      }

      if (side == "Right") {
        this.lastclientPhotosRight = [];

        db.collection("clientphotos")
          .where("company", "==", this.activeComp)
          .where("salonhub_ID", "==", Number(this.chosenCustomerInfo.id))
          .where("datePhoto", "==", this.selectedDateRight)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              if (doc.data().photoBA == 0) {
                this.BAright = 0;
              } else {
                this.BAright = 1;
              }

              let clientphoto = doc.data();
              clientphoto.id = doc.id;
              this.lastclientPhotosRight.push(clientphoto);
            });
          })
          .then(() => {
            if (this.lastclientPhotosRight.length == 0) {
              //Niks doen
            } else {
              this.imageRight = this.lastclientPhotosRight[0].photoCollection.front;
            }
          })
          .catch(error => {
            // The document probably doesn't exist.
            console.error("Error document: ", error);
          });
      }
    },

    async removePhotos(data){
      await new Promise((resolve)=>{
        let counter = 0;
        if(data.length > 0){
          data.forEach(photoDoc=>{
            db.collection("clientphotos").doc(photoDoc.id).delete()
            .then(()=>{
              counter++
              if(counter == data.length){
                resolve()
              }
            })
            .catch(()=>{
              counter++
              if(counter == data.length){
                resolve()
              }
            })
            
          })
        }
        else{
          resolve()
        }
      })
      this.getComparePhotos(this.customerID)
      
    },

    calculateHeight(){
      if(this.activeComp == 'beautybyroos'){
        return 70;
      } 
      else{
        return 100;
      }
    },

    closedialog() {
      this.comparephotoModal = false;
    }
  },
  computed: {
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>

<style>
  @media screen and (orientation: landscape) {
    .turntolandscape {
      display: none;
    }
  }

  @media screen and (orientation: portrait) {
    .landscapeturn {
      display: none;
    }
  }

  .image-date-selector .v-select {
    padding: 25px 0 0 0;
    max-width: 320px;
  }

  .hogans-modal-header {
    position: relative;
    padding: 20px 25px;
    background-color: #00adef;
  }

  .hogans-modal-header h2 {
    font-size: 18px;
    color: #ffffff;
  }

  .hogans-modal-header-close {
    position: absolute;
    background: url("../../assets/icons/close-icon-white.svg") no-repeat center
      center;
    background-size: 16px;
    width: 20px;
    height: 20px;
    right: 20px;
    top: 50%;
    margin: -10px 0 0 0;
  }

  .hogans-modal-header-close:hover {
    cursor: pointer;
  }

  .hogans-modal-footer {
    /* padding: 15px; */
  }

  .modal-button-cancel {
    display: inline-block;
    float: left;
    text-decoration: none;
    padding: 14px 15px;
    height: 44px;
    font-size: 14px;
    line-height: 12px;
    color: #8b93a6;
    font-weight: 600;
    border-radius: 5px;
    border: 2px solid #e8e9ee;
    margin: 0 15px 0 0;
  }

  .modal-button-cancel:hover {
    background: #ffffff;
    background-image: linear-gradient(-240deg, invalid gradient);
    box-shadow: 0 8px 21px 0 rgba(229, 0, 125, 0.3);
    border: none;
    padding: 16px 17px;
    color: #e5007d;
    cursor: pointer;
  }

  span.BeforeAfter {
    margin: 0 0 0 2px;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 6px 4px 6px 4px;
    border-radius: 5px;
    color: white;
    position: absolute;
    bottom: 12px;
    font-size: 14px;
  }
  .no-radius{
    border-radius: 0px!important;
  }
</style>